import { StatusChip, type StatusKind } from "../ui-x";

/**
 * The app's status vocabulary, mapped onto the reference's six chip kinds.
 * Per the spec, a status is re-labelled rather than re-coloured — the chip
 * always shows the record's own wording, only the palette is normalised.
 */
const KIND_BY_STATUS: Record<string, StatusKind> = {
  /* ready — finished well, or live and healthy */
  open: "ready",
  finished: "ready",
  completed: "ready",
  complete: "ready",
  paid: "ready",
  successful: "ready",
  successfull: "ready",
  accepted: "ready",
  approved: "ready",
  active: "ready",
  available: "ready",
  verified: "ready",
  settled: "ready",
  /* A talent saying yes is a good outcome, not something still in review. */
  interested: "ready",

  /* progress — in flight. Amber, which is where "pending" belongs: it is
     waiting on somebody else, not flagged for review by us. */
  "on-going": "progress",
  ongoing: "progress",
  "in-progress": "progress",
  "in progress": "progress",
  onboarding: "progress",
  pending: "progress",
  "to-start": "progress",
  processing: "progress",
  started: "progress",
  interviewed: "progress",

  /* review — waiting on somebody */
  unpaid: "review",
  awaiting: "review",
  review: "review",
  "in-review": "review",
  submitted: "review",
  offered: "review",
  invited: "review",
  requested: "review",

  /* draft — not started, or unknown standing */
  draft: "draft",
  "not-invited": "draft",
  "not verified": "draft",
  unverified: "draft",
  incomplete: "draft",
  inactive: "draft",

  /* suspended — went wrong, or a clear no */
  declined: "suspended",
  "not interested": "suspended",
  "not-interested": "suspended",
  rejected: "suspended",
  failed: "suspended",
  cancelled: "suspended",
  canceled: "suspended",
  suspended: "suspended",
  expired: "suspended",
  disputed: "suspended",

  /* exited — over, without judgement */
  closed: "exited",
  ended: "exited",
  exited: "exited",
  terminated: "exited",
  withdrawn: "exited",
};

/* The two sentinels the old component special-cased. */
const SENTINEL_LABELS: Record<string, string> = {
  "1": "Interested",
  "0": "Not Offered",
};

export default function Status({ label }: { label: string }) {
  const key = (label ?? "").toString().trim().toLowerCase();

  const status: StatusKind =
    key === "1"
      ? "review"
      : key === "0"
      ? "draft"
      : KIND_BY_STATUS[key] ?? "draft";

  return (
    <StatusChip
      status={status}
      label={SENTINEL_LABELS[key] ?? label}
      className="capitalize"
    />
  );
}
